import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { Alert, CircularProgress } from "@mui/material";
import { getArticles } from "../../utils/articlesApi";
import "./Articles.css";

function Articles() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        setError(null);
        const data = await getArticles();
        setArticles(Array.isArray(data) ? data : []);
      } catch (err) {
        console.error("Error fetching articles:", err);
        setError(err.message || "Не можеме да ги вчитаме статиите.");
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const featuredArticle = useMemo(
    () => (articles.length > 0 ? articles[0] : null),
    [articles]
  );
  const remainingArticles = useMemo(() => articles.slice(1), [articles]);

  const extractExcerpt = (text, words = 28) => {
    const plain = String(text || "").replace(/<[^>]*>/g, " ").trim();
    if (!plain) return "Дознајте повеќе во целата статија.";
    const parts = plain.split(/\s+/).slice(0, words);
    return `${parts.join(" ")}${parts.length >= words ? "..." : ""}`;
  };

  const formatDate = (value) => {
    if (!value) return "";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "";
    return date.toLocaleDateString("mk-MK", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  if (loading) {
    return (
      <div className="articles-page">
        <div className="articles-shell articles-loading">
          <CircularProgress />
        </div>
      </div>
    );
  }

  return (
    <div className="articles-page">
      <div className="articles-shell">
        <section className="articles-hero">
          <p className="articles-eyebrow">Инспирација</p>
          <h1>Свадбени статии</h1>
          <p className="articles-subtitle">
            Идеи, совети и трендови за да го испланирате вашиот најважен ден.
          </p>
        </section>

        {error && (
          <div className="articles-alert">
            <Alert severity="error">{error}</Alert>
          </div>
        )}

        {featuredArticle?.slug && (
          <Link
            to={`/articles/${featuredArticle.slug}`}
            className="article-featured-card"
          >
            <img
              src={
                featuredArticle.cover_picture_url ||
                "https://placehold.co/1200x700/f6f4ef/7f6f65?text=Kazhavda"
              }
              alt={featuredArticle.title}
              className="article-featured-image"
            />
            <div className="article-featured-overlay">
              <span className="article-featured-date">
                {formatDate(featuredArticle.created_at)}
              </span>
              <h2>{featuredArticle.title}</h2>
              <p>{extractExcerpt(featuredArticle.short_description, 36)}</p>
            </div>
          </Link>
        )}

        <section className="articles-grid-section">
          <div className="articles-grid-v2">
            {remainingArticles
              .filter((article) => Boolean(article?.slug))
              .map((article) => (
              <Link
                key={article.id}
                to={`/articles/${article.slug}`}
                className="article-card-v2"
              >
                <img
                  src={
                    article.cover_picture_url ||
                    "https://placehold.co/700x420/f6f4ef/7f6f65?text=Kazhavda"
                  }
                  alt={article.title}
                  className="article-card-image-v2"
                />
                <div className="article-card-content-v2">
                  <span className="article-card-date-v2">
                    {formatDate(article.created_at)}
                  </span>
                  <h3>{article.title}</h3>
                  <p>{extractExcerpt(article.short_description)}</p>
                  <span className="article-read-more-v2">Прочитај повеќе</span>
                </div>
              </Link>
            ))}
          </div>
          {articles.length === 0 && !error && (
            <p className="articles-empty">Нема статии во моментов.</p>
          )}
        </section>

        <div className="articles-footer-v2">
          <Link to="/#articles-section" className="articles-home-link">
            Почетна
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Articles;
